import { useEffect, useState } from 'react';

const CountDown = ({ seconds, onEnd, delay = 0, prefix='', endfix='' }) => {
  const [timeLeft, setTimeLeft] = useState(Math.floor(seconds + delay / 1000));
  const [show, setShow] = useState(false);

  useEffect(() => {
    // 如果时间已经为0，调用onEnd回调并退出
    if (timeLeft === 0) {
      if (onEnd) {
        onEnd();
      }
      return;
    }

    // 设置一个定时器来减少时间
    const timerId = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // 清除定时器的副作用
    return () => clearTimeout(timerId);
  }, [timeLeft, onEnd]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setShow(true);
    }, delay);

    // 清除定时器的副作用
    return () => clearTimeout(timerId);
  }, []);

  return (show ?
    <>
      {prefix + timeLeft + endfix}
    </> : null
  );
};

export default CountDown;
